module.exports = __webpack_public_path__ + "images/emoji/sparkle.0e9fd45c8da8c8e836c7.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/sparkle.png
// module id = KxKg
// module chunks = 24